<template>
    <vx-card :title='$t("Contacts")' collapse-action>
        <div class="mt-6">
            <vs-table v-model="selected" @selected="handleSelected" :data="contacts">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center mb-3">
                        <vs-button v-if="$checkPermission(307)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addClientContactPrompt = true">{{$t("Add")}}</vs-button>
                    </div>

                </div>

                <template slot="thead">
                    <vs-th>{{$t("Name")}}</vs-th>
                    <vs-th>{{$t("Email")}}</vs-th>
                    <vs-th>{{$t("PhoneNumber")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                        <vs-td :data="data[indextr].name + ' ' + data[indextr].l_name">
                            {{data[indextr].name  + ' ' + data[indextr].l_name}}
                        </vs-td>

                        <vs-td :data="data[indextr].email">
                            {{data[indextr].email}}
                        </vs-td>
                        <vs-td :data="data[indextr].phone">
                            {{data[indextr].phone}}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Add')" :active.sync="addClientContactPrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="contactAdd['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("LName")}}</p>
                <vs-input v-model="contactAdd['l_name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Email")}}</p>
                <vs-input v-model="contactAdd['email']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("PhoneNumber")}}</p>
                <vs-input v-model="contactAdd['phone']" style="width: 100%"></vs-input>
                <vs-divider icon-pack="feather" icon="icon-lock" position="center" color="danger"/>
                <contact-permissions ref="addPermissions" :permissions="contactAdd['permissions']"/>
                <vs-divider color="danger"/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addContact">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editClientContactPrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="contactEdit['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("LName")}}</p>
                <vs-input v-model="contactEdit['l_name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Email")}}</p>
                <vs-input v-model="contactEdit['email']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("PhoneNumber")}}</p>
                <vs-input v-model="contactEdit['phone']" style="width: 100%"></vs-input>
                <vs-divider icon-pack="feather" icon="icon-lock" position="center" color="danger"/>
                <contact-permissions ref="editPermissions" :permissions="contactEdit['permissions']"/>
                <vs-divider color="danger"/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editContact">{{$t("Save")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeContact">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    import ContactPermissions from "./ContactPermissions";

    export default {
        components: {
            ContactPermissions
        },
        props: {
            clientId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                contacts: [],
                addClientContactPrompt: false,
                contactAdd: {},

                editClientContactPrompt: false,
                contactEdit: {},
                selected: {},

            }
        },
        computed: {
          contactMap: function () {
              let list = {};
              for(let x = 0; x < this.contacts.length; x++){
                  list[this.contacts[x].id] = this.contacts[x]
              }
              return list;
          }
        },
        watch: {
            editClientContactPrompt: function () {
                if(!this.editClientContactPrompt){
                    this.selected = {}
                }
            }
        },
        methods: {
            handleSelected(tr) {
                this.contactEdit = Object.assign({}, tr);
                this.editClientContactPrompt = true;
            },
            isPromptOpen() {
                return this.addClientContactPrompt || this.editClientContactPrompt;
            },
            closePrompts(){
                this.addClientContactPrompt = false;
                this.editClientContactPrompt = false;
            },
            updateClientContacts() {
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.clientId + '/contacts')
                    .then(function (response) {
                        thisIns.contacts = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addContact() {
                const thisIns = this;
                this.contactAdd['permissions'] = this.$refs.addPermissions.permissionArray;
                this.$http.post('/api/v1/client/' + this.clientId + '/contacts', this.contactAdd)
                .then(function () {
                    thisIns.updateClientContacts();
                    thisIns.addClientContactPrompt = false;

                    thisIns.contactAdd = {};
                }).catch(function (error) {
                    thisIns.addClientContactPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editContact(){
                const thisIns = this;
                this.contactEdit['permissions'] = this.$refs.editPermissions.permissionArray;
                this.$http.put('/api/v1/client/' + this.clientId + '/contacts/' + this.selected.id, this.contactEdit)
                    .then(function () {
                        thisIns.updateClientContacts();
                        thisIns.editClientContactPrompt = false;
                    }).catch(function (error) {
                    thisIns.editClientContactPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeContact(){
                const thisIns = this;
                this.$http.delete('/api/v1/client/' + this.clientId + '/contacts/' + this.selected.id)
                    .then(function () {
                        thisIns.updateClientContacts();
                        thisIns.editClientContactPrompt = false;
                    }).catch(function (error) {
                    thisIns.editClientContactPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updateClientContacts();
        },
    }

</script>
